export default "__VITE_ASSET__BpajUlbL__"